import type { FaireProductEntity } from "../../entity_types/product";

export const p_mgsujmdxfg: FaireProductEntity = {
  token: "p_mgsujmdxfg",
  type: "product",
  name: "Smoky Quartz Crystal Polished Points - BRAZIL",
  brandToken: "b_4w78fajgal",
  brandName: "Meraki Gemstones",
  imageUrl:
    "https://cdn.faire.com/fastly/e93b550343b6d7aacf344d329c83c58bc348dbf77a2efae29c1441c2ef5163bc.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d744e2add99e5c8d8cabd012acd3b7337247ce56de162b44c203ac4c884e42cf.jpeg",
    "https://cdn.faire.com/fastly/7caa38d35e8a69bdde7e6b9158435d9a4d1fcc0428329abd7a7a757f846ebf9b.jpeg",
    "https://cdn.faire.com/fastly/8c41447c20b29de2b545e1cb0686f74c995cbd0e31d41ef39a36f22593fbebd1.jpeg",
    "https://cdn.faire.com/fastly/c710c7d29e207e792197aab0f1e407155584dfa67d2576e5de210fc5f49f7bd3.jpeg",
    "https://cdn.faire.com/fastly/ae8c06be3dde17e500c1ead1464689e9886468267aa224406a63f81f4c996b23.jpeg",
  ],
  priceDollars: 41.57,
  description:
    'Stunning Smoky Quartz Polished Points with wonderful energy. \n\nSmoky quartz is a variety of quartz that ranges in color from light gray or brown to nearly black, and is prized both as a gemstone and for metaphysical purposes.\n\nGrounding: Thought to connect users to the earth and stabilize emotions.\nProtection: Believed to absorb and transmute negative energy.\nClarity: Helps with clear thinking and emotional calmness.\n\n* AAA - Quality \n\n*Approximately  1"- 3"  in size\n* 15-20 Polished points per KG\n*Sold in 500 Grams (1.1 Lbs) increments\n\nMade in Brazil\n\nThis picture is a representation of the type and quality of the gemstone you will be receiving.  As you know, there are slight variations due to the natural character of this product.',
  tags: [],
  msrpDollars: 124.71,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:07:18.134Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
